import { TeamLegalCasesMutations } from './partials/legal_cases'
import { TeamMemberMutations } from './partials/members'
import { TeamPartyMutations } from './partials/parties'
import { TeamRecordMutations } from './partials/records'
import { TeamRoleMutations } from './partials/roles'

export const TeamMutations = {
  setTeams: (state, data) => { state.teams = data },
  ...TeamLegalCasesMutations,
  ...TeamMemberMutations,
  ...TeamPartyMutations,
  ...TeamRecordMutations,
  ...TeamRoleMutations,
}
